import type { ReportHistoryEntryType } from '@api';
import { formatDateTime, PersonAnchor } from '@common';
import { Button, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { isReportHistoryEntryReviewable } from '../../helpers';

type ReviewedTableCellPropsType = {
  entry: ReportHistoryEntryType;
  canReview: boolean;
  isPending: boolean;
  onMarkAsReviewed: (entryId: string) => void;
};

export const ReviewedTableCell: React.FC<ReviewedTableCellPropsType> = ({
  entry,
  canReview,
  isPending,
  onMarkAsReviewed,
}) => {
  const { t } = useTranslation();

  if (entry.reviewedAt !== null) {
    const { reviewedBy } = entry;

    return (
      <Stack gap={0}>
        {reviewedBy && (
          <Text size="sm">
            {t('REPORTS.HISTORY.REVIEWED_BY')}{' '}
            {reviewedBy.type === 'PERSON' ? (
              <PersonAnchor person={reviewedBy} />
            ) : (
              reviewedBy.name
            )}
          </Text>
        )}
        <Text size="sm">{formatDateTime(entry.reviewedAt)}</Text>
      </Stack>
    );
  }

  if (canReview && isReportHistoryEntryReviewable(entry)) {
    return (
      <Button
        variant="outline"
        color="orange"
        size="xs"
        loading={isPending}
        onClick={() => onMarkAsReviewed(entry.id)}
      >
        {t('REPORTS.HISTORY.MARK_AS_REVIEWED')}
      </Button>
    );
  }

  return t('NO_DATA_PLACEHOLDER');
};
